import type { INavigationStore } from "../../../stores/navigation";
import { Screens } from "../../../stores/navigation";
import { Measures } from "../../../types/entities";
import { formatTypeTag, normalizeTypeTag } from "../../../utils/typeTags";

export function getProductsByMeasureTitle(measure: Measures): string {
  if (measure === Measures.weight) {
    return "Товары по мере: вес";
  }
  if (measure === Measures.liters) {
    return "Товары по мере: литры";
  }

  return "Товары по мере: количество";
}

export function openProductsListByMeasure(
  navigationStore: INavigationStore,
  measure: Measures,
): void {
  navigationStore.setScreen(Screens.ProductsList, {
    title: getProductsByMeasureTitle(measure),
    measure,
  });
}

export function openProductsListByTypeTag(
  navigationStore: INavigationStore,
  tag: string,
): boolean {
  const normalizedTag = normalizeTypeTag(tag || "");
  if (!normalizedTag) {
    return false;
  }

  navigationStore.setScreen(Screens.ProductsList, {
    title: `Товары по тегу ${formatTypeTag(normalizedTag)}`,
    typeTag: normalizedTag,
  });
  return true;
}
